import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Bridge } from "../_";
import { EditOutlined } from '@ant-design/icons';
import { useLocalStorageState } from 'ahooks';
import { FloatButton } from 'antd';
import React, { useEffect } from 'react';
import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import { SuperDashboardContext } from "./Context";
import { SuperDashboardEditor } from "./Editor";
export var ResponsiveGridLayout = WidthProvider(Responsive);
export var SuperDashboard = function SuperDashboard(properties) {
  var _Bridge$useLocation = Bridge.useLocation(),
    pathname = _Bridge$useLocation.pathname;
  var _useLocalStorageState = useLocalStorageState("JiShuXin['Page']['".concat(pathname, "']['Layout']"), {
      defaultValue: {
        editing: false,
        currentLayout: {
          md: properties.defaultLayout
        },
        defaultLayout: properties.defaultLayout
      },
      listenStorageChange: true
    }),
    _useLocalStorageState2 = _slicedToArray(_useLocalStorageState, 2),
    environment0 = _useLocalStorageState2[0],
    setEnvironment0 = _useLocalStorageState2[1];
  var environment = environment0,
    setEnvironment = function setEnvironment(environment1) {
      return setEnvironment0(_objectSpread(_objectSpread({}, environment0), environment1));
    };
  var primaryContent = /*#__PURE__*/React.createElement(ResponsiveGridLayout, {
    breakpoints: {
      sm: 576,
      md: 768
    },
    margin: [24, 24],
    rowHeight: Math.pow(2, 6.6),
    cols: {
      md: 6,
      sm: 1
    },
    layouts: environment.currentLayout,
    isDroppable: environment.editing,
    isResizable: environment.editing,
    isDraggable: environment.editing,
    onLayoutChange: function onLayoutChange(_, allLayouts) {
      return setEnvironment({
        currentLayout: allLayouts
      });
    }
  }, properties.children);
  useEffect(function () {
    setEnvironment({
      defaultLayout: properties.defaultLayout
    });
  }, [properties.defaultLayout]);
  return /*#__PURE__*/React.createElement(SuperDashboardContext.Provider, {
    value: [environment, setEnvironment]
  }, /*#__PURE__*/React.createElement(FloatButton, {
    icon: /*#__PURE__*/React.createElement(EditOutlined, null),
    onClick: function onClick() {
      return setEnvironment({
        editing: true
      });
    },
    style: {
      insetBlockEnd: 24,
      display: environment.editing ? 'none' : undefined
    }
  }), /*#__PURE__*/React.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n            .ant-pro-layout .ant-pro-layout-content {\n              padding-block: ".concat(environment.editing ? 0 : 12, "px !important;\n              padding-inline: ").concat(environment.editing ? 0 : 12, "px !important;\n              background-color: #F5F7FA !important;\n            }\n          ")
    }
  }), environment.editing ? /*#__PURE__*/React.createElement(SuperDashboardEditor, null, primaryContent) : primaryContent);
};